import { FunctionComponent } from 'react';
import { useConfig } from '@browsing/config';
import { useConsentManager } from '@browsing/tracking';

import { toNumberOrZero } from '@client/helpers';
import { addUsabillaToWindow } from './script';

export const Usabilla: FunctionComponent = () => {
    const config = useConfig();
    const [hasConsent] = useConsentManager('usabilla_lounge');

    const visits = toNumberOrZero(window.localStorage.getItem('zl_mylounge_page_view_count'));
    if (config?.isEnabled('usabilla') && hasConsent) {
        addUsabillaToWindow({
            campaignId: (config.usabilla as { campaignId?: string }).campaignId,
            auxiliaryData: {
                myLoungePageViewCount: visits,
            },
        });
    }

    return null;
};

export default Usabilla;
